// extracted by mini-css-extract-plugin
module.exports = {"link":"gameTease-module__link___X_CVb","title":"gameTease-module__title___p-SjS","summary":"gameTease-module__summary___1PONM","arrow":"gameTease-module__arrow___2yxi1"};